import {Component, HostListener, inject, OnInit, output, signal, ViewChild} from '@angular/core';
import {Select} from 'primeng/select';
import {FormsModule} from '@angular/forms';
import {Panel} from 'primeng/panel';
import {InputText} from 'primeng/inputtext';
import {MultiSelect} from 'primeng/multiselect';
import {AsyncPipe, NgClass, NgIf, NgStyle} from '@angular/common';
import {Popover} from 'primeng/popover';
import {ButtonDirective, ButtonLabel} from 'primeng/button';
import {coalesce, FetchRequest, RestResponse, SelectItemPipe} from '@abydos-angular/core';
import {PartnerClientFacade} from '../../../partner-client/store/partner-client.facade';
import {ActivityFacade} from '../../store/activity.facade';
import {PartnerClientRepository} from '../../../partner-client/store/partner-client.repository';
import {PartnerClientRestService} from '../../../partner-client/api/partner-client-rest.service';
import {ActivityVO} from '../../store/activity.interfaces';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {PartnerClientVO} from '../../../partner-client/store/partner-client.interfaces';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Dialog} from 'primeng/dialog';
import {AuthFacade} from '@abydos-angular/rest-api';
import {Router} from '@angular/router';
import {BreakpointObserver, Breakpoints, LayoutModule} from '@angular/cdk/layout';

@Component({
    selector: 'app-activity-searcher',
    imports: [
        Select,
        FormsModule,
        Panel,
        InputText,
        MultiSelect,
        NgStyle,
        NgClass,
        Popover,
        ButtonDirective,
        NgIf,
        AsyncPipe,
        SelectItemPipe,
        ButtonLabel,
        Dialog,
        LayoutModule
    ],
    templateUrl: './activity-searcher.component.html',
    standalone: true,
    styleUrl: './activity-searcher.component.scss',
    providers: [PartnerClientFacade, PartnerClientRepository, PartnerClientRestService]
})
export class ActivitySearcherComponent implements OnInit{
    public selectItems = this.activityFacade.selectItems;
    public activityFilterName?: string;
    public activityFilterClientPartner: number | null = null;
    public eventFilterCategories: number[] = [];
    selectedActivity?: ActivityVO;
    // ha kérik majd a leíráshoz a html szerkesztőt
    htmlText = '';
    activitySelectionEmitter = output<ActivityVO | undefined>()
    partnerList = signal<any[]>([]) // = toSignal(this.eventFacade.listPartners(), {initialValue: []})
    activityList = signal<any[]>([]) //  = toSignal(this.eventFacade.listServices(), {initialValue: null});
    filteredActivityList: ActivityVO[] = [];
    showDialog = false;
    isMobile = false;
    private breakpointObserver = inject(BreakpointObserver);
    showButton = false;

    @HostListener('window:scroll')
    onWindowScroll() {
        this.showButton = window.scrollY > 1500;
    }

    constructor( private partnerClientFacade: PartnerClientFacade, public authFacade: AuthFacade,
        private activityFacade: ActivityFacade, private messageService: MessageService, private confirmationService: ConfirmationService,
                 private router: Router) {
    }

    ngOnInit() {
        this.activityFacade.initSelectItems();
        const request = new FetchRequest();
        this.partnerClientFacade.list(request, (result: RestResponse) => {
            if (isNotNullOrUndefined(result.getData())) {
                this.partnerList.set(result.getData()!);
            }
        })
        this.activityFacade.list(request, (result: RestResponse) => {
            if (isNotNullOrUndefined(result.getData())) {
                this.activityList.set(result.getData()!)
                const element = document.getElementById('searcher-start');
                setTimeout(() => element?.scrollIntoView({ behavior: 'smooth' }));
            }
        })
        this.breakpointObserver.observe([Breakpoints.Handset])
            .subscribe(result => {
                this.isMobile = result.matches;
            });
    }

    getFilterCategories(selectItems: any) {
        return selectItems.get("activityLabel") || [];
    }

    // ha kérik majd a leíráshoz a html szerkesztőt
    testHtml() {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.htmlText, 'text/html');
            return doc.body ? doc.body.innerHTML : this.htmlText;
        } catch {
            return this.htmlText;
        }
    }

    activitySelected() {
        this.activitySelectionEmitter.emit(this.selectedActivity)
    }

    filterActivities() {
        let returnedList: any = this.activityList()
        if (this.activityFilterClientPartner !== null) {
            returnedList =  returnedList?.filter((activity: any) => activity.partnerClient.id === Number(this.activityFilterClientPartner))
        }
        if (coalesce(this.activityFilterName?.length, 0)! > 0) {
            returnedList = returnedList?.filter((activity: any) => activity.name.toLowerCase().includes(this.activityFilterName?.toLowerCase()));
        }
        if (this.eventFilterCategories?.length > 0) {
            returnedList = returnedList?.filter((activity: any) => {
                const categoryIds = activity.categories?.map((category:any) => category.id)
                // activity.categories?.includes(this.eventFilterCategories[0])
                return categoryIds?.includes(this.eventFilterCategories[0]);
            });
        }
        this.filteredActivityList = returnedList;
        return;
    }

    getActivityList() {
        if (this.filteredActivityList?.length > 0) {
            return this.filteredActivityList;
        } else {
            return this.activityList();
        }
    }

    openPartnerDescription(partnerClient: PartnerClientVO) {
        this.authFacade.isUserLoggedIn.subscribe(isUserLoggedIn => {
            if (isUserLoggedIn) {
                this.partnerClientFacade.getWithCallback(partnerClient.id!,   (result: any) => {
                    if (isNotNullOrUndefined(result?.dynamicValues?.description)) {
                        this.activityFacade.getPartnerDocumentWithCallback(result?.dynamicValues?.description, response => {
                            this.htmlText = response.documentBodyAsString || 'Nem található leírás';// .replace(/<body([^>]*)>/, `<body$1>${this.sampleHtml}`)
                            this.showDialog = true;
                        })
                    } else {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Leírás nem található!',
                            detail: 'A partner nem adott meg leírást ehhez a szervezethez!',
                            life: 3000,
                        });
                    }
                })
            } else {
                this.confirmationService.confirm({
                    key: 'yes_no_only',
                    header: 'Bejelentkezés szükséges!',
                    message: '<pre>Ehhez a funkcióhoz be kell lépned a felhasználói fiókodba!\n\nSzeretnél most bejelentkezni?</pre>',
                    accept: () => {
                        this.router.navigateByUrl('login').then();
                    }
                });
            }
        })
    }

    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}
